export { default } from "./src/article-cta";
